// extracted by mini-css-extract-plugin
export default {"color":"WebTag_color__E1SqM"};